import { createEmptyAttendedDate, createEmptyArtist } from '../utils/eventDefaults'

export const useEventArrays = (event, setEvent) => {
  // Attended Dates Management
  const handleAttendedDatesChange = (index, field, value) => {
    const updatedDates = [...event.attendedDates]
    updatedDates[index] = { ...updatedDates[index], [field]: value }
    setEvent(prev => ({ ...prev, attendedDates: updatedDates }))
  }

  const addAttendedDate = () => {
    setEvent(prev => ({
      ...prev,
      attendedDates: [...prev.attendedDates, createEmptyAttendedDate()]
    }))
  }

  const removeAttendedDate = (index) => {
    const updatedDates = event.attendedDates.filter((_, i) => i !== index)
    setEvent(prev => ({ ...prev, attendedDates: updatedDates }))
  }

  // Artists Management
  const handleArtistChange = (index, field, value) => {
    const updatedArtists = [...event.artistsSeen]

    // If value is an object and field is 'bulk', update multiple fields at once
    if (field === 'bulk' && typeof value === 'object') {
      updatedArtists[index] = { ...updatedArtists[index], ...value }
    } else {
      updatedArtists[index] = { ...updatedArtists[index], [field]: value }
    }

    setEvent(prev => ({ ...prev, artistsSeen: updatedArtists }))
  }

  const addArtist = () => {
    setEvent(prev => ({
      ...prev,
      artistsSeen: [...prev.artistsSeen, createEmptyArtist()]
    }))
  }

  const removeArtist = (index) => {
    const updatedArtists = event.artistsSeen.filter((_, i) => i !== index)
    setEvent(prev => ({ ...prev, artistsSeen: updatedArtists }))
  }

  return {
    handleAttendedDatesChange,
    addAttendedDate,
    removeAttendedDate,
    handleArtistChange,
    addArtist,
    removeArtist
  }
}